<div class="modal-body text-center">
    <p translate>Are you sure you want to show this reply?</p>
    <form #showReplyForm="ngForm">
        <div class="form-group">
            <label class="checkbox__label checkbox__label--size-small" for="isUserUnblock">
                {{ 'Show all post/comments from this user' | translate }}
                <input type="checkbox" id="isUserUnblock" name="isUserUnblock" required [(ngModel)]="isUserUnblock" />
                <span class="checkbox__checkmark"></span>
            </label>
        </div>
    </form>
    <button type="button" class="btn btn-default" (click)="decline()" translate>Cancel</button>
    <button type="button" class="btn btn-primary ms-2" (click)="confirm()" translate>Show</button>
</div>
